import { SxProps, Theme } from '@mui/material';

type TStyles = {
  timerText: SxProps<Theme>;
};

export const styles: TStyles = {
  timerText: (theme) => ({
    textAlign: 'center',
    color: theme.palette.error.main,
    fontSize: { xs: '12px', sm: '14px' },
  }),
};
